<template>
	<a :href="productUrl" class="product-tile" :data-element-id="`X_X_Tiles_Tile${index + 1}_IMG`"
		@mouseenter="loadSecondImage">
		<div class="product-top">
			<div class="badge-container">
				<div v-if="discountPercentage > 0" class="product-badge discount-badge" :class="{
					'twenty': discountPercentage === 20,
					'twentyfive': discountPercentage === 25,
					'thirty': discountPercentage === 30,
					'fifty': discountPercentage === 50
				}">-{{ discountPercentage }}%</div>
				<div v-if="firstBadge" class="product-badge first-badge">{{ firstBadge }}</div>
				<div v-if="secondBadge" class="product-badge second-badge"
					:class="{ 'speedy-rx-badge': secondBadge === '2-DAY SPEEDY DELIVERY' }">{{ secondBadge }}</div>
				<div v-if="NewBadgeMeta" class="product-badge second-badge">{{ NewBadgeMeta }}</div>
			</div>
			<div v-if="!isFlatPLP" class="product-colors">{{ product.colorsNumber }} colors</div>
		</div>
		<div v-if="isLargeTile" class="product-image-container"
			:class="{ 'fade-transition fade-ready': hasAlternateTransition, 'fade-ready': bothImagesLoaded }">
			<div v-if="!firstImageRemoveLoader" class="dots-loader first-loader">
			</div>
			<div v-if="(!secondImageRemoveLoader && !isMobile)" class="dots-loader  hover-loader">
			</div>
			<img class="product-image first-image"
				:src="(isMobile ? getFirstImage(product.firstImgUrl) : getSecondImage(product.secondImgUrl))"
				alt="Product Image" loading="lazy" @load="onFirstImageRemoveLoader" />
			<img v-if="((secondImageLoaded && !isMobile) || hasAlternateTransition)" class="product-image hover-image"
				:src="isMobile && hasAlternateTransition ? getSecondImage(product.secondImgUrl) : getFirstImage(product.firstImgUrl)"
				alt="Product Image" loading="lazy" @load="onSecondImageRemoveLoader" />
		</div>
		<div v-else class="product-image-container"
			:class="{ 'fade-transition': hasAlternateTransition, 'fade-ready': bothImagesLoaded }">
			<div v-if="!firstImageRemoveLoader" class="dots-loader first-loader">
			</div>
			<div v-if="(!secondImageRemoveLoader && !isMobile)" class="dots-loader  hover-loader"></div>
			<img class="product-image first-image"
				:src="(isMobile && !hasAlternateTransition ? getSecondImage(product.secondImgUrl) : getFirstImage(product.firstImgUrl))"
				alt="Product Image" loading="lazy" @load="onFirstImageRemoveLoader" />
			<img v-if="((secondImageLoaded && !isMobile) || hasAlternateTransition)" class="product-image hover-image"
				:src="getSecondImage(product.secondImgUrl)" alt="Product Image" loading="lazy"
				@load="onSecondImageRemoveLoader" />
		</div>
		<div class="product-info">
			<div class="product-code">{{ getModelName() }}</div>
			<div class="product-brand">{{ product.brand }}</div>
			<div class="product-prices">
				<div class="product-prices-container">
					<div class="product-list-price"
						:class="{ 'line-through': product.offerPrice !== product.listPrice }">$
						{{ product.listPrice }}</div>
					<div v-if="product.offerPrice !== product.listPrice" class="product-offer-price">$ {{
						product.offerPrice
					}}</div>
				</div>
				<div class="complete-pair" v-if="getIncludingLensesLabel()">{{ completePairLabel }}</div>
			</div>
		</div>
	</a>
</template>

<script>
import ProductTile from "./ProductTile.ts";
export default {
	...ProductTile,
};
</script>
<style lang="scss">
@import "./ProductTile.scss";
</style>
